<template>
    <DropdownList
        @dropdownListOpen=onDropdownListOpen
        @dropdownListClose=onDropdownListClose
        class="more-actions align-right"
    >
        <template #select>
            <ActionButton
                v-tooltip='"global.actions.more"'
                icon='fas fa-ellipsis-v'
            />
        </template>

        <template #options>
            <slot name="actions"> </slot>
        </template>
    </DropdownList>
</template>

<script setup>
  import {defineEmits} from 'vue';
  import ActionButton  from '@/vue/Elements/Buttons/ActionButton.vue';
  import DropdownList  from './DropdownList.vue';

  const emit = defineEmits([
    'moreActionsOpen', 'moreActionsClose',
  ])

  const onDropdownListOpen = () => {
    emit('moreActionsOpen');
  }

  const onDropdownListClose = () => {
    emit('moreActionsClose');
  }
</script>